import { Component, OnInit } from '@angular/core';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { DEVICE_SEARCH_CRITERIA_KEY, DeviceSearchCriteria } from '../../../models/searchCriteria/DeviceSearchCriteria';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Device } from '../../../models/Device';
import { DeviceService } from '../../../services/device.service';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { AlertService } from '../../shared/alert/alert.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-device-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ConfirmAlertComponent,
    FilterPanelComponent,
    HasPermissionDirective,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './device-list.component.html',
  styleUrl: './device-list.component.scss'
})
export class DeviceListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: DeviceSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: DeviceSearchCriteria = { ...this.emptySearchCriteria };

  devices: Device[] = [];

  selectedDevice?: Device;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private deviceService: DeviceService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(DEVICE_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, DEVICE_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  edit(deviceId?: string) {
    this.router.navigate(['devices/' + deviceId]);
  }


  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, DEVICE_SEARCH_CRITERIA_KEY);
    this.deviceService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.devices = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }

  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as DeviceSearchCriteria
    this.find();
  }


  confirmOperation(device: Device, confirmOperationType: "DEL" | undefined) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage = "Eliminazione palmare - Sicuro di voler eliminare il palmare " + device.name;
    }
    this.selectedDevice = device;
  }


  cancelModalOperationExec() {
    this.selectedDevice = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.deviceService.delete(this.selectedDevice!.id!).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
          this.cancelModalOperationExec();
          this.fullSpinnerService.spinner(undefined);
          this.find()
        }, complete: () => {

        }
        , error: () => {
          this.cancelModalOperationExec();
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}

